import styled, { css } from 'styled-components'
import toString from 'lodash/toString'
import themeColors from '@layers-frontend/commons/styles/themeColors'

// The comparison dates hang from the top bar like tabs: its navy, with a mint contour on the free edges.
export const DateBox = styled.div`
  position: absolute;
  top: 60px;
  padding: 2px 4px;
  background: ${themeColors.deepblueColor3};
  width: 60px;
  text-align: center;
  font-family: Roboto;
  font-size: 10px;
  color: ${themeColors.whiteTransparent08};

  ${props =>
    toString(props.align) === 'left' &&
    css`
      left: -60px;
      border-bottom-left-radius: 8px;
      box-shadow: inset 1px 0 0 ${themeColors.mintBorder}, inset 0 -1px 0 ${themeColors.mintBorder};
    `};

  ${props =>
    toString(props.align) === 'right' &&
    css`
      left: 10px;
      border-bottom-right-radius: 8px;
      box-shadow: inset -1px 0 0 ${themeColors.mintBorder}, inset 0 -1px 0 ${themeColors.mintBorder};
    `};
`
